import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogConfig } from './dialog-config';
import { DialogIcon } from './dialog-icon.enum';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: false,
})
export class DialogComponent {
  private dialogRef = inject<MatDialogRef<DialogConfig>>(MatDialogRef);

  public DialogIcon = DialogIcon;
  public icon: DialogIcon;
  public title: string;
  public content: string[];
  public secondary: string;
  public primary: string;

  constructor() {
    const data = inject<DialogConfig>(MAT_DIALOG_DATA);

    this.icon = data.icon;
    this.title = data.title;
    if (data.content) {
      this.content = typeof data.content === 'string' ? [data.content] : data.content;
    } else {
      this.content = [];
    }
    if (data.secondary) {
      this.secondary = data.secondary;
    }
    if (data.primary) {
      this.primary = data.primary;
    }
  }

  public show(field) {
    return typeof field !== 'undefined' && field !== null && field !== '';
  }

  public secondaryClick() {
    this.dialogRef.close(false);
  }

  public primaryClick() {
    this.dialogRef.close(true);
  }
}
